// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5867":"css/app.6841","7850":"css/admin-app.6841"}[chunkId] + ".css";
};